import { CountryCode, Language } from '@pkgs/api';

export const EV_FINANCE_URL = 'https://www.ev-finance.de/finanzierung?utm_source=engelvoelkers_website&utm_medium=online_expose&utm_id=1';

export const FINANCING_ENABLED_COUNTRIES: ReadonlySet<CountryCode> = new Set([CountryCode.DE, CountryCode.ES]);

export const getEVFinancingURL = (displayID: string, countryCode: CountryCode, language: Language, price?: number): string => {
    let url;
    if (countryCode === CountryCode.ES) {
      switch (language) {
        case Language.es:
          url = new URL('https://ev-finance.es/es/financiacion?utm_source=engelvoelkers_website&utm_medium=online_expose');
          break;
        case Language.ca:
          url = new URL('https://ev-finance.es/ca/financiacion?utm_source=engelvoelkers_website&utm_medium=online_expose');
          break;
        case Language.de:
          url = new URL('https://ev-finance.es/de/finanzierung?utm_source=engelvoelkers_website&utm_medium=online_expose');
          break;
        default:
          url = new URL('https://ev-finance.es/en/financing?utm_source=engelvoelkers_website&utm_medium=online_expose');
          break;
      }
    } else {
      url = new URL(EV_FINANCE_URL);
    }
  
    url.searchParams.append('displayID', displayID);
    if (price) {
      url.searchParams.append('price', price.toString());
    }
    return url.toString();
  };
  
  export const financingImages: Partial<Record<CountryCode, string>> = {
    [CountryCode.ES]: 'https://uploadcare.engelvoelkers.com/300ff5a0-85fc-4012-bbef-b21c8cafbb0b/',
    [CountryCode.DE]: 'https://uploadcare.engelvoelkers.com/4f54bf1d-3464-41cb-8e7d-d6afd5d35b08/',
  };
  